import Api from 'api'

const config = {
  baseURL: '/api/app/v2',
}
const api = new Api(config)

api.fetchCampaigns = ({ network, ...rest }) =>
  api.get(`/${network}/pulse/dates`, { ...rest })

api.fetchCampaignsDemo = ({ network, ...rest }) =>
  api.get(`/${network}/demo/pulse/dates`, { ...rest })

export default api
